import { render } from "./SearchImageComponent.vue?vue&type=template&id=586bded4"
import script from "./SearchImageComponent.vue?vue&type=script&lang=js"
export * from "./SearchImageComponent.vue?vue&type=script&lang=js"

import "./SearchImageComponent.vue?vue&type=style&index=0&id=586bded4&lang=css"

import exportComponent from "/home/dev.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__